<mad-data-table
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [paginationEnabled]="true"
  [filterEnabled]="true"
  [defaultPageSize]="10"
>
</mad-data-table>
